import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClientJsonpModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AscediaDesignSystemModule } from 'ascedia-design-system';
import { GoogleMapsModule } from '@angular/google-maps';

//NPM MODULES
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { 
	faArrowLeft as fasArrowLeft,
	faArrowRight as fasArrowRight,
	faBedAlt as fasBedAlt,
	faCalendarAlt as fasCalendarAlt,
	faChevronLeft,
	faChevronRight,
	faCircle,
	faCheck,
	faCheckCircle,
	faCodeMerge,
	faComments,
	faCreditCardFront as fasCreditCardFront,
	faCrosshairs as fasCrosshairs,
	faDollarSign as fasDollarSign,
	faEmptySet as fasEmptySet,
	faExclamation as fasExclamation,
	faExclamationCircle as fasExclamationCircle,
	faExclamationTriangle as fasExclamationTriangle,
	faExternalLinkAlt as fasExternalLinkAlt,
	faList,
	faMapMarkerAlt as fasMapMarkerAlt,
	faMinus as fasMinus,
	faPlus as fasPlus,
	faQuestionCircle as fasQuestionCircle,
	faSearch,
	faShareSquare as fasShareSquare,
	faTh as fasTh,
	faThumbsUp as fasThumbsUp,
	faThumbsDown as fasThumbsDown,
	faTimes as fasTimes,
	faSignIn as fasSignIn,
	faSync as fasSync,
	faUserHeadset as fasUserHeadset,
	faWater as fasWater
} from '@fortawesome/pro-solid-svg-icons';

import { 
	faBinoculars as farBinoculars,
	faCalendar as farCalendar,
	faCalendarTimes as farCalendarTimes,
	faCommentCheck as farCommentCheck,
	faClock as farClock,
	faLockAlt as farLockAlt,
	faHeart as farHeart,
	faLightbulbOn as farLightbulbOn,
	faShieldCheck as farShieldCheck,
	faShip as farShip,
	faSlidersH as farSlidersH,
	faShoppingCart as farShoppingCart,
	faTags as farTags,
	faTrashAlt as farTrashAlt,
	faUsers as farUsers,
	faUsdCircle as farUsdCircle,
	faUmbrellaBeach as farUmbrellaBeach
} from '@fortawesome/pro-regular-svg-icons';

import { 
	faComments as falComments,
	faHandshake as falHandshake,
	faMinus,
	faPlus,
	faTicketAlt as falTicketAlt,
} from '@fortawesome/pro-light-svg-icons';

import { 
	faCalendarAlt as fadCalendarAlt,
} from '@fortawesome/pro-duotone-svg-icons';

import { 
	faFacebook,
	faInstagram,
} from '@fortawesome/free-brands-svg-icons';


import { EnterTheViewportNotifierDirective } from '../shared/directives/enter-viewport.directive';
import { RedirectWithHrefDirective } from './directives/redirect-with-href.directive';

import { AnchorTabsComponent } from './anchor-tabs/anchor-tabs.component';
import { BtnCommonComponent } from './buttons/btn-common.component';
import { BtnSaveComponent } from './buttons/btn-save.component';
import { HeaderComponent } from './header/header.component';
import { SafetyComponent } from './safety/safety.component';
import { ReadMoreComponent } from './read-more/read-more.component';
import { InputTextGroupComponent } from './input-text-group/input-text-group.component';
import { ResponseMessageComponent } from './response-message/response-message.component';
import { MsalInterceptor } from '@azure/msal-angular';


@NgModule({
	declarations: [
		AnchorTabsComponent,
		BtnCommonComponent,
		BtnSaveComponent,
		HeaderComponent,
		InputTextGroupComponent,
		SafetyComponent,
		ReadMoreComponent,
		EnterTheViewportNotifierDirective,
		RedirectWithHrefDirective,
		ResponseMessageComponent
	],
	imports: [
		CommonModule,
		FontAwesomeModule,
		FormsModule,
		HttpClientModule,
		HttpClientJsonpModule,
		GoogleMapsModule,
		ReactiveFormsModule,
		RouterModule,
		AscediaDesignSystemModule,
		ModalModule.forRoot(),
		PopoverModule.forRoot(),
		BsDatepickerModule.forRoot(),
	],
	providers: [
		CookieService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MsalInterceptor,
			multi: true
		}
	],
	exports: [
		AnchorTabsComponent,
		AscediaDesignSystemModule,
		BtnCommonComponent,
		BtnSaveComponent,
		EnterTheViewportNotifierDirective,
		FontAwesomeModule,
		FormsModule,
		HttpClientModule,
		HttpClientJsonpModule,
		HeaderComponent,
		GoogleMapsModule,
		InputTextGroupComponent,
		SafetyComponent,
		ReactiveFormsModule,
		ReadMoreComponent,
		ResponseMessageComponent,
		PopoverModule,
		BsDatepickerModule
	]
})
export class SharedModule {
	constructor(library: FaIconLibrary){
		library.addIcons(fasArrowLeft);
		library.addIcons(fasArrowRight);
		library.addIcons(farBinoculars);
		library.addIcons(fasBedAlt);
		library.addIcons(farCalendar);
		library.addIcons(fadCalendarAlt);
		library.addIcons(fasCalendarAlt);
		library.addIcons(farCalendarTimes);
		library.addIcons(farClock);
		library.addIcons(faChevronLeft);
		library.addIcons(faChevronRight);
		library.addIcons(faCircle);
		library.addIcons(faCheck);
		library.addIcons(faCheckCircle);
		library.addIcons(faCodeMerge);
		library.addIcons(farCommentCheck);
		library.addIcons(faComments);
		library.addIcons(falComments);
		library.addIcons(fasCreditCardFront);
		library.addIcons(fasCrosshairs);
		library.addIcons(fasDollarSign);
		library.addIcons(fasEmptySet);
		library.addIcons(fasExclamation);
		library.addIcons(fasExclamationCircle);
		library.addIcons(fasExclamationTriangle);
		library.addIcons(fasExternalLinkAlt);
		library.addIcons(faFacebook);
		library.addIcons(falHandshake);
		library.addIcons(farHeart);
		library.addIcons(faInstagram);
		library.addIcons(farLightbulbOn);
		library.addIcons(faList);
		library.addIcons(farLockAlt);
		library.addIcons(fasMapMarkerAlt);
		library.addIcons(faMinus);
		library.addIcons(fasMinus);
		library.addIcons(faPlus);
		library.addIcons(fasPlus);
		library.addIcons(fasQuestionCircle);
		library.addIcons(fasShareSquare);
		library.addIcons(faSearch);
		library.addIcons(farShieldCheck);
		library.addIcons(farShip);
		library.addIcons(farShoppingCart);
		library.addIcons(farSlidersH);
		library.addIcons(farTags);
		library.addIcons(fasTh);
		library.addIcons(fasThumbsUp);
		library.addIcons(fasThumbsDown);
		library.addIcons(fasTimes);
		library.addIcons(falTicketAlt);
		library.addIcons(farTrashAlt);
		library.addIcons(farUmbrellaBeach);
		library.addIcons(farUsers);
		library.addIcons(farUsdCircle);
		library.addIcons(fasSignIn);
		library.addIcons(fasSync);
		library.addIcons(fasUserHeadset);
		library.addIcons(fasWater);
	}
}
